import { FormBase } from 'core/components';

export default class ExportForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				{
					name: 'startDate',
					label: 'FULFILLMENTORDER.EXPORT.STARTINGSHIPPINGDATE',
				},
				{
					name: 'endDate',
					label: 'FULFILLMENTORDER.EXPORT.ENDINGSHIPPINGDATE',
				},
				{
					name: 'shipByStartDate',
					label: 'FULFILLMENTORDER.EXPORT.STARTINGSHIPBYDATE',
				},
				{
					name: 'shipByEndDate',
					label: 'FULFILLMENTORDER.EXPORT.ENDINGSHIPBYDATE',
				},
				{
					name: 'useShipByDate',
					label: 'FULFILLMENTORDER.EXPORT.USESHIPBYDATE',
					type: 'checkbox',
				},
			],
		};
	}
}
